export function dateFormatter(inputDate: string, includeTime: boolean = true, lang: string = 'tr'): string {
    if (!inputDate) {
        return '';
    }

    // ISO 8601 formatındaki tarihi Date nesnesine dönüştürüyoruz
    const dateObj = new Date(inputDate);
    // Geçerli tarih olup olmadığını kontrol ediyoruz
    if (isNaN(dateObj.getTime())) {
        console.warn(`Geçersiz tarih değeri: ${inputDate}`);
        return '';  // Geçersiz tarih durumunda boş bir değer döndürülür
    }
    // `includeTime` seçeneğine göre tarih formatını belirliyoruz
    let options: Intl.DateTimeFormatOptions = {};

    if (lang.startsWith('tr')) {
        // Türkçe için gün/ay/yıl formatı
        options = includeTime
            ? { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }
            : { day: '2-digit', month: '2-digit', year: 'numeric' };
    } else {
        // Diğer diller için yıl/ay/gün formatı
        options = includeTime
            ? { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }
            : { year: 'numeric', month: '2-digit', day: '2-digit' };
    }

    // `Intl.DateTimeFormat` ile formatlıyoruz
    const formatter = new Intl.DateTimeFormat(lang, options);
    //console.log(formatter.format(dateObj),'formatted date')
    return formatter.format(dateObj);
}
